/* @flow */

import { List } from 'immutable'
import i18n from 'atpjs/helpers/i18n'
import { getTopics } from 'tve/api/atp'

import type DataHandler from 'atpjs/data_handler'

type SubjectType = {
  label: string,
  value: string,
  icon: string,
  tooltipTitle?: string,
  tooltipContent?: string
}
type SubjectArrayType = Array<SubjectType>

export const clientSegmentCodeByData = (data: DataHandler): string => {
  const login = data.get('login')
  const customerType = data.get('customerType')
  return (login ? '' : 'prospect-') + (customerType == 'private' ? 'pk' : 'fk')
}

const subjectIcons = {
  finance: 'topic-finance-private',
  found: 'topic-founding',
  invest: 'topic-invest',
  investover: 'topic-invest-plus',
  investuntil: 'topic-invest',
  occupational_precaution: 'topic-security',
  payment_saving: 'topic-services-private',
  payment: 'topic-services-business',
  precaution: 'topic-security',
  succession: 'topic-succession'
}

export const subjectsByData = (data: DataHandler): SubjectArrayType => {
  return filterTopics({ clientSegmentCode: clientSegmentCodeByData(data) }).reduce((arr, topic) => {
    let tooltip = {}
    const code = topic.get('code')
    const titleTrans = topic.get('name')
    const tooltipTrans = topic.get('description')
    if (tooltipTrans) {
      tooltip = {
        tooltipTitle: titleTrans,
        tooltipContent: tooltipTrans
      }
    }
    return arr.concat({
      label: titleTrans,
      value: code,
      icon: subjectIcons[code] || '',
      ...tooltip
    })
  }, [])
}

const mediumIcons = {
  bank: 'channel-in-the-bank',
  personal: 'channel-home-of-client',
  phone: 'channel-over-phone',
  video: 'channel-over-video'
}

export const topicsBySubject = (data: DataHandler, additionalFilter: Object = {}) => {
  const clientSegmentCode = clientSegmentCodeByData(data)
  return data.get('subject').reduce((list, code) => {
    return list.concat(filterTopics({ ...additionalFilter, clientSegmentCode, code }))
  }, List())
}

const sortPriority = (topicA, topicB) => {
  return topicA.get('priority') - topicB.get('priority')
}

const mostRelevant = (data: DataHandler) => {
  return topicsBySubject(data)
    .sort(sortPriority)
    .last()
}

export const mediumsByData = (data: DataHandler): MediumArrayType => {
  return mostRelevant(data)
    .get('supportedMedia')
    .toJS()
    .map((medium) => {
      return {
        value: medium,
        label: i18n.deep(['options', 'mediums', data.get('customerType'), medium]),
        icon: mediumIcons[medium]
      }
    })
}

export const filterTopics = (filter) => {
  const keys = Object.keys(filter)
  return getTopics().filter((topic) => {
    return keys.every((key) => {
      const value = topic.get(key)
      if (List.isList(value)) return value.includes(filter[key])
      return value == filter[key]
    })
  })
}

export const existingCustomer = (data) => {
  const id = data.getIn(['clientSegment', 'id'])
  return Number(id) === id && data.get('login')
}
